export default {
  setBookingResourcesTypes: (state, value) => {
    state.bookingResourcesTypes = value;
  },

  setBookingResourcesStatuses: (state, value) => {
    state.bookingResourcesStatuses = value;
  },

  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
